"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var collapseNodes_1 = require("../utils/collapseNodes");
var isNodeInRegion_1 = require("./isNodeInRegion");
/**
 * Collapse nodes within this region to their common ascenstor node under this region
 * @param region The region to collapse nodes in.
 * @param nodes Nodes to collapse. All nodes not contained by the given region will be ignored.
 */
function collapseNodesInRegion(region, nodes) {
    nodes = nodes && nodes.filter(function (node) { return isNodeInRegion_1.default(region, node); });
    if (!nodes || nodes.length == 0) {
        return [];
    }
    var firstNode = nodes[0];
    var lastNode = nodes[nodes.length - 1];
    if (isNodeInRegion_1.default(region, firstNode) && isNodeInRegion_1.default(region, lastNode)) {
        return collapseNodes_1.default(region.rootNode, firstNode, lastNode, true /*canSplitParent*/);
    }
    else {
        return [];
    }
}
exports.default = collapseNodesInRegion;
//# sourceMappingURL=collapseNodesInRegion.js.map